import { Check, ArrowRight, MessageCircle } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PRICING_INCLUDES, PROGRAM_DETAILS } from "../../data/site";
import { scrollToId, waLink, PHONE_DISPLAY } from "../../lib/contact";

export const ProgramDetails = () => (
  <section data-testid="pricing-section" className="py-24 sm:py-28 bg-background">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        align="center"
        overline="Program Information"
        title="One Program. Complete Details."
        sub="Transparent pricing and structure for the full 45-day practical journey."
      />
      <div className="mt-14 grid lg:grid-cols-5 gap-8 max-w-6xl mx-auto items-start">
        <Reveal className="lg:col-span-3">
          <div className="bg-white border border-slate-200/80 rounded-2xl overflow-hidden" data-testid="program-details-card">
            {PROGRAM_DETAILS.map(([k, v], i) => (
              <div
                key={k}
                data-testid={`program-detail-${k.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`flex items-center justify-between gap-4 px-6 sm:px-8 py-4 ${i % 2 ? "bg-background" : "bg-white"} ${i ? "border-t border-slate-100" : ""}`}
              >
                <span className="text-sm text-slate-500">{k}</span>
                <span className="font-display font-semibold text-navy text-sm text-right">{v}</span>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-2">
          <div data-testid="pricing-card" className="relative bg-navy rounded-3xl overflow-hidden shadow-2xl shadow-navy/30">
            <div className="absolute inset-0 bg-grid-navy" />
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-electric/25 blur-[100px]" />
            <div className="relative p-8">
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyanx">Program Fee</p>
              <p className="mt-3 font-display font-extrabold text-white text-5xl tracking-tight" data-testid="pricing-amount">₹14,999</p>
              <p className="mt-2 text-sm text-slate-400">Complete 45-day program · Limited seats</p>
              <div className="mt-7 pt-7 border-t border-white/10 space-y-2.5">
                {PRICING_INCLUDES.map((inc) => (
                  <div key={inc} className="flex items-start gap-2.5" data-testid={`pricing-include-${inc.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                    <span className="w-5 h-5 rounded-full bg-electric/25 flex items-center justify-center shrink-0 mt-0.5">
                      <Check size={11} strokeWidth={3} className="text-cyanx" />
                    </span>
                    <span className="text-sm text-slate-300 leading-snug">{inc}</span>
                  </div>
                ))}
              </div>
              <div className="mt-8 flex flex-col gap-3">
                <button
                  data-testid="pricing-cta-book"
                  onClick={() => scrollToId("contact")}
                  className="group inline-flex items-center justify-center gap-2 bg-electric hover:bg-electric-dark text-white font-semibold text-sm rounded-full px-7 py-4 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-electric/40"
                >
                  Book Free Counselling
                  <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </button>
                <a
                  data-testid="pricing-cta-whatsapp"
                  href={waLink()}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-cyanx/60 text-slate-200 font-semibold text-sm rounded-full px-7 py-4 transition-colors"
                >
                  <MessageCircle size={16} /> Call / WhatsApp: {PHONE_DISPLAY}
                </a>
              </div>
              <p className="mt-6 text-[11px] text-slate-500 leading-relaxed">
                Live advertising budget, paid software, domains, product samples, inventory or external platform charges for individual student projects are separate unless specifically stated.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
